import moment from "moment";

const getHours = (hrs) => {
  const roundedTotalHours = parseFloat(hrs.toFixed(2));

  const hours = Math.floor(roundedTotalHours);
  const minutes = Math.floor((roundedTotalHours % 1) * 60);

  const totalString = `${hours}:${minutes.toString().padStart(2, "0")}`;

  return totalString;
};

function generateCSV(data, typeD) {
  if (typeD === "worktime") {
    const csvContent = [];

    csvContent.push(
      "Project Name,Task Name,Start Date,Start Time,End Date,End Time,Type,Description,Total Hours"
    );
    data.forEach((tasks) => {
      const {
        projectName,
        taskName,
        trackerStartDate,
        trackerStartTime,
        trackerEndDate,
        trackerEndTime,
        type,
        description,
        totalHours,
      } = tasks;

      csvContent.push(
        `${projectName},${taskName},${trackerStartDate},${trackerStartTime},${trackerEndDate},${trackerEndTime},${type},${description},${getHours(
          totalHours
        )}`
      );
    });

    // for pdf print download start.
    let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
    // let selectedProject = localStorage.getItem("projectForPrint");
    // let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
    // let selectedClientName = localStorage.getItem("clientNameForPrint");
    let employeeName = localStorage.getItem("firstname");

    let pdfTitle = `${employeeName}-Worktime Report,-${workspaceName}-${moment(
      new Date()
    ).format("YYYY.MM.DD, h:mm a")}.csv`;
    // for pdf print download end.

    const csvString = csvContent.join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = pdfTitle;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    return null;
  }

  const csvContent = [];

  csvContent.push(
    "First Name,Last Name,Project Name,Task Name,Start Date,Start Time,End Date,End Time,Type,Description,Total Hours,Is Approved"
  );

  data.forEach((user) => {
    const firstName = user.firstName;
    const lastName = user.lastName;

    user.dateWiseTasksList.forEach((tasks) => {
      tasks.forEach((task) => {
        const {
          projectName,
          taskName,
          trackerStartDate,
          trackerStartTime,
          trackerEndDate,
          trackerEndTime,
          type,
          description,
          totalHours,
          isApproved,
        } = task;

        csvContent.push(
          `${firstName},${lastName},${projectName},${taskName},${trackerStartDate},${trackerStartTime},${trackerEndDate},${trackerEndTime},${type},${description},${getHours(
            totalHours
          )},${isApproved}`
        );
      });
    });
  });

  // for pdf print download start.
  let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
  // let selectedProject = localStorage.getItem("projectForPrint");
  // let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
  // let selectedClientName = localStorage.getItem("clientNameForPrint");
  let employeeName = localStorage.getItem("firstname");

  let pdfTitle2 = `${employeeName}-Worktime Report,-${workspaceName}-${moment(
    new Date()
  ).format("YYYY.MM.DD, h:mm a")}.csv`;
  // for pdf print download end.

  const csvString = csvContent.join("\n");

  const blob = new Blob([csvString], { type: "text/csv" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = pdfTitle2;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
}

export { generateCSV };
